/* Kontoseite der App (Vorlage page.app-konto): baut Bestellungen und Daten aus der Antwort der App.
   Die App liefert nur an diese Seite (Plugin „Checkout“, account); das Zugangstoken sieht die Seite nie.
   Alle Texte kommen aus dem Abschnitt „App: Mein Konto“ bzw. den Sprachdateien. */
(() => {
  const root = document.querySelector('[data-acct]');
  if (!root) return;
  const body = root.querySelector('[data-acct-body]');
  const title = root.querySelector('[data-acct-title]');
  const T = JSON.parse(root.querySelector('[data-acct-text]').textContent);
  const plugin = window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Checkout;
  const bridge = window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.AppBridge;
  // Schutz mit Face ID / Fingerabdruck: Wahl der Kundin auf diesem Gerät; einmal entsperrt, 5 Minuten offen
  const LOCK = 'softriot:acct-lock';
  const UNLOCKED = 'softriot:acct-unlocked';
  const store = (s, k, v) => { try { if (v === undefined) return s.getItem(k); if (v === null) s.removeItem(k); else s.setItem(k, v); } catch (e) { /* egal */ } return null; };
  const locked = () => store(localStorage, LOCK) === '1' && Date.now() - Number(store(sessionStorage, UNLOCKED) || 0) > 5 * 60 * 1000;
  const lang = document.documentElement.lang || 'de';

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const httpsUrl = (u) => { try { const x = new URL(u); return x.protocol === 'https:' ? x.toString() : ''; } catch (e) { return ''; } };
  const sized = (u, w) => { try { const x = new URL(u); x.searchParams.set('width', w); return x.toString(); } catch (e) { return ''; } };
  const money = (m) => { try { return new Intl.NumberFormat(lang, { style: 'currency', currency: m.currencyCode }).format(Number(m.amount)); } catch (e) { return `${m.amount} ${m.currencyCode}`; } };
  const date = (d) => { try { return new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(d)); } catch (e) { return ''; } };

  /* Ein Status pro Bestellung, vom Wichtigsten her: storniert → Sendungsstand → Versandstand → Zahlung */
  function status(order) {
    const s = T.status;
    if (order.cancelledAt) return { key: 'cancelled', text: s.cancelled };
    if (order.financialStatus === 'REFUNDED') return { key: 'refunded', text: s.refunded };
    const ship = (order.fulfillments && order.fulfillments.nodes || []).map((f) => f.latestShipmentStatus).filter(Boolean);
    if (ship.includes('DELIVERED')) return { key: 'delivered', text: s.delivered };
    if (ship.includes('OUT_FOR_DELIVERY')) return { key: 'out', text: s.out };
    if (ship.includes('READY_FOR_PICKUP')) return { key: 'pickup', text: s.pickup };
    if (order.fulfillmentStatus === 'FULFILLED') return { key: 'shipped', text: s.shipped };
    if (order.fulfillmentStatus === 'PARTIALLY_FULFILLED') return { key: 'partial', text: s.partial };
    if (order.financialStatus === 'PENDING' || order.financialStatus === 'AUTHORIZED') return { key: 'pending', text: s.pending };
    return { key: 'workshop', text: s.workshop };
  }

  function orderCard(order) {
    const st = status(order);
    const items = (order.lineItems && order.lineItems.nodes) || [];
    const tracking = [];
    (order.fulfillments && order.fulfillments.nodes || []).forEach((f) => (f.trackingInformation || []).forEach((t) => {
      const url = httpsUrl(t.url);
      if (url) tracking.push({ url, company: t.company });
    }));
    const thumbs = items.slice(0, 4).map((i) => i.image && httpsUrl(i.image.url)
      ? `<img class="acct-order__img" src="${esc(sized(httpsUrl(i.image.url), 160))}" alt="${esc(i.image.altText || i.name)}" width="64" height="64" loading="lazy">`
      : `<span class="acct-order__img acct-order__img--empty" aria-hidden="true"></span>`).join('');
    const names = items.slice(0, 3).map((i) => `${i.quantity > 1 ? `${i.quantity} × ` : ''}${esc(i.name)}${i.variantTitle ? ` <span class="acct-muted">${esc(i.variantTitle)}</span>` : ''}`).join('<br>');
    const more = items.length > 3 ? `<br><span class="acct-muted">${esc(T.more.replace('[anzahl]', items.length - 3))}</span>` : '';
    const statusUrl = httpsUrl(order.statusPageUrl);
    return `
      <article class="acct-order acct-order--${st.key}">
        <header class="acct-order__head">
          <div>
            <p class="acct-order__name">${esc(order.name)}</p>
            <p class="acct-muted">${esc(date(order.processedAt))}</p>
          </div>
          <span class="acct-pill acct-pill--${st.key}">${esc(st.text)}</span>
        </header>
        <div class="acct-order__items">
          <div class="acct-order__thumbs">${thumbs}</div>
          <p class="acct-order__names">${names}${more}</p>
        </div>
        <footer class="acct-order__foot">
          <strong class="acct-order__total">${esc(money(order.totalPrice))}</strong>
          <span class="acct-order__actions">
            ${tracking.map((t) => `<a class="btn btn--signal acct-btn" href="${esc(t.url)}">${esc(T.track)}${t.company ? ` <span class="acct-btn__sub">${esc(t.company)}</span>` : ''}</a>`).join('')}
            ${statusUrl ? `<a class="btn btn--ghost acct-btn" href="${esc(statusUrl)}">${esc(T.details)}</a>` : ''}
          </span>
        </footer>
      </article>`;
  }

  // Stempelkarte: Die App holt die Karte mit der Anmeldung vom App-Backend und zeigt „Zur Wallet hinzufügen“
  // (nur angemeldet; ohne Anmeldung kennt das Backend die Bestellungen nicht)
  const stamp = root.querySelector('[data-app-stamp]');
  const showStamp = (on) => { if (stamp) stamp.hidden = !(on && plugin && plugin.wallet); };
  if (stamp && plugin && plugin.wallet) {
    stamp.addEventListener('click', () => {
      stamp.classList.add('is-loading');
      stamp.disabled = true;
      plugin.wallet().catch((e) => { if (e && e.message) window.alert(e.message); })
        .finally(() => { stamp.classList.remove('is-loading'); stamp.disabled = false; });
    });
  }

  // Vorname für den Gruß im Wisch-Header (theme.js), nur auf diesem Gerät
  const NAME = 'lorayn:first-name';
  const keepName = (v) => { try { if (v) localStorage.setItem(NAME, v); else localStorage.removeItem(NAME); } catch (e) { /* ohne Speicher kein Name */ } };

  function renderSignedIn(c) {
    showStamp(true);
    const first = c.firstName || '';
    keepName(first);
    title.textContent = first && T.greeting ? T.greeting.replace('[vorname]', first) : T.title;
    const orders = (c.orders && c.orders.nodes) || [];
    const address = c.defaultAddress && c.defaultAddress.formatted || [];
    const email = c.emailAddress && c.emailAddress.emailAddress;
    const phone = c.phoneNumber && c.phoneNumber.phoneNumber;
    const editUrl = `${root.dataset.accountUrl.replace(/\/$/, '')}/profile`;
    body.innerHTML = `
      <section class="acct-block">
        <h2 class="acct-block__title display">${esc(T.ordersTitle)}</h2>
        ${orders.length ? orders.map(orderCard).join('') : `<p class="acct-empty">${esc(T.ordersEmpty)}</p>`}
      </section>
      <section class="acct-block">
        <h2 class="acct-block__title display">${esc(T.dataTitle)}</h2>
        <dl class="acct-data">
          ${[c.firstName, c.lastName].filter(Boolean).length ? `<div><dt class="visually-hidden">Name</dt><dd class="acct-data__name">${esc([c.firstName, c.lastName].filter(Boolean).join(' '))}</dd></div>` : ''}
          ${email ? `<div><dt>${esc(T.email)}</dt><dd>${esc(email)}</dd></div>` : ''}
          ${phone ? `<div><dt>${esc(T.phone)}</dt><dd>${esc(phone)}</dd></div>` : ''}
          ${address.length ? `<div><dt>${esc(T.address)}</dt><dd>${address.map(esc).join('<br>')}</dd></div>` : ''}
        </dl>
        <div data-acct-lock hidden></div>
        <p class="acct-links">
          <a class="acct-link" href="${esc(editUrl)}">${esc(T.edit)} →</a>
        </p>
      </section>
      <p class="acct-out"><button type="button" class="btn btn--ghost" data-acct-signout>${esc(T.signOut)}</button></p>
      ${plugin && plugin.deleteAccount ? `<section class="acct-del" data-acct-del>
        <button type="button" class="acct-del__link" data-acct-del-open aria-expanded="false">${esc(T.del.link)}</button>
      </section>` : ''}`;
    body.querySelector('[data-acct-signout]').addEventListener('click', (e) => {
      e.currentTarget.disabled = true;
      keepName('');
      // Die App räumt die Shop-Sitzung und lädt die Seite danach selbst neu
      plugin.signOut().catch(() => window.location.reload());
    });
    renderLockToggle(body.querySelector('[data-acct-lock]'));
    const del = body.querySelector('[data-acct-del]');
    if (del) {
      del.querySelector('[data-acct-del-open]').addEventListener('click', () => renderDeleteForm(del));
      // Läuft schon ein Löschauftrag, gleich dessen Stand zeigen
      plugin.deleteStatus().then((r) => { if (r && r.job) renderDeleteStatus(del, r.job, r.stale); }).catch(() => {});
    }
  }

  /* Konto löschen: Erklärung, Bestätigung, dann Antrag über die App (Worker prüft die Identität bei Shopify) */
  function renderDeleteForm(box) {
    const D = T.del;
    box.innerHTML = `
      <h2 class="acct-block__title display">${esc(D.title)}</h2>
      <p>${esc(D.intro)}</p>
      <p class="acct-muted">${esc(D.keep)}</p>
      <label class="acct-del__check"><input type="checkbox" data-acct-del-ok> <span>${esc(D.confirm)}</span></label>
      <p class="acct-del__msg" data-acct-del-msg role="alert" hidden></p>
      <p class="acct-del__actions">
        <button type="button" class="btn acct-del__btn" data-acct-del-go disabled>${esc(D.button)}</button>
        <button type="button" class="btn btn--ghost" data-acct-del-cancel>${esc(D.cancel)}</button>
      </p>`;
    const go = box.querySelector('[data-acct-del-go]');
    const msg = box.querySelector('[data-acct-del-msg]');
    box.querySelector('[data-acct-del-ok]').addEventListener('change', (e) => { go.disabled = !e.currentTarget.checked; });
    box.querySelector('[data-acct-del-cancel]').addEventListener('click', load);
    go.addEventListener('click', () => {
      go.disabled = true;
      msg.hidden = true;
      plugin.deleteAccount().then((r) => {
        // Gerät vergisst die Kundin: Merkzettel, zuletzt angesehen und Vorlieben dieses Handys
        ['softriot:wish', 'softriot:wish-checked', 'softriot:recent', 'softriot:myshirt', 'softriot:height', 'softriot:acct-lock'].forEach((k) => { try { localStorage.removeItem(k); } catch (e) { /* egal */ } });
        renderDeleteStatus(box, r.job);
      }).catch((err) => {
        go.disabled = false;
        msg.textContent = err && err.code === 'rate' ? T.del.errorRate : T.del.error;
        msg.hidden = false;
      });
    });
  }

  function renderDeleteStatus(box, job, stale) {
    const D = T.del;
    const st = ['requested', 'processing', 'done', 'failed'].includes(job.status) ? job.status : 'requested';
    box.innerHTML = `
      <h2 class="acct-block__title display">${esc(D.sentTitle)}</h2>
      <p class="acct-del__status acct-del__status--${st}">${esc(D[st])}</p>
      ${stale && job.updatedAt ? `<p class="acct-muted">${esc(D.stale.replace('[datum]', date(job.updatedAt * 1000)))}</p>` : ''}
      ${st === 'failed' ? `<p><button type="button" class="btn btn--ghost" data-acct-del-again>${esc(D.retry)}</button></p>` : ''}`;
    const again = box.querySelector('[data-acct-del-again]');
    if (again) again.addEventListener('click', () => renderDeleteForm(box));
  }

  function renderSignedOut() {
    showStamp(false);
    keepName('');
    title.textContent = T.title;
    body.innerHTML = `
      <div class="acct-welcome">
        <p class="acct-welcome__text">${esc(T.signedOutText)}</p>
        <button type="button" class="btn btn--signal btn--block" data-acct-signin>${esc(T.signIn)}</button>
      </div>`;
    body.querySelector('[data-acct-signin]').addEventListener('click', (e) => {
      const btn = e.currentTarget;
      btn.disabled = true;
      plugin.signIn().then(load).catch((err) => {
        btn.disabled = false;
        if (err && err.code !== 'cancelled') renderError();
      });
    });
  }

  function renderError() {
    showStamp(false);
    body.innerHTML = `
      <div class="acct-welcome">
        <p class="acct-welcome__text">${esc(T.error)}</p>
        <button type="button" class="btn btn--ink" data-acct-retry>${esc(T.retry)}</button>
      </div>`;
    body.querySelector('[data-acct-retry]').addEventListener('click', load);
  }

  /* Schalter „Mit Face ID schützen“ (nur wenn das Gerät eine Sperre kann) */
  function renderLockToggle(box) {
    if (!box || !bridge || !bridge.biometry) return;
    bridge.biometry().then((r) => {
      if (!r || !r.available) return;
      box.hidden = false;
      box.innerHTML = `<label class="acct-del__check acct-lock"><input type="checkbox" data-acct-lock-on ${store(localStorage, LOCK) === '1' ? 'checked' : ''}>
        <span>${esc(T.lock[r.kind] || T.lock.code)}<br><span class="acct-muted">${esc(T.lock.hint)}</span></span></label>`;
      box.querySelector('[data-acct-lock-on]').addEventListener('change', (e) => {
        const input = e.currentTarget;
        // Einschalten und Ausschalten nur mit erfolgreichem Entsperren
        bridge.unlock({ reason: T.lock.reason }).then((u) => {
          if (u && u.ok) {
            store(localStorage, LOCK, input.checked ? '1' : null);
            store(sessionStorage, UNLOCKED, String(Date.now()));
          } else input.checked = !input.checked;
        }).catch(() => { input.checked = !input.checked; });
      });
    }).catch(() => {});
  }

  function renderLocked() {
    showStamp(false);
    title.textContent = T.title;
    body.innerHTML = `
      <div class="acct-welcome">
        <p class="acct-welcome__text">${esc(T.lock.locked)}</p>
        <button type="button" class="btn btn--signal btn--block" data-acct-unlock>${esc(T.lock.unlock)}</button>
      </div>`;
    body.querySelector('[data-acct-unlock]').addEventListener('click', load);
  }

  function load() {
    if (bridge && bridge.unlock && locked()) {
      bridge.unlock({ reason: T.lock.reason }).then((u) => {
        if (u && u.ok) {
          store(sessionStorage, UNLOCKED, String(Date.now()));
          load();
        } else renderLocked();
      }).catch(renderLocked);
      return;
    }
    body.innerHTML = '<div class="acct__loading"><span class="acct__dot"></span><span class="acct__dot"></span><span class="acct__dot"></span></div>';
    plugin.account()
      .then((res) => (res && res.signedIn ? renderSignedIn(res.customer || {}) : renderSignedOut()))
      .catch(renderError);
  }

  // Zahnrad: native Einstellungsseite (nur App-Versionen mit AppBridge.openSettings)
  const gear = root.querySelector('[data-acct-settings]');
  if (gear && bridge && bridge.openSettings) {
    let cfg = null;
    try { cfg = JSON.parse(root.querySelector('[data-acct-settings-cfg]').textContent); } catch (e) { /* ohne Konfiguration kein Zahnrad */ }
    if (cfg) {
      const color = (v) => {
        const probe = document.createElement('i');
        probe.style.cssText = `position:absolute;visibility:hidden;color:var(${v})`;
        document.body.appendChild(probe);
        const c = getComputedStyle(probe).color;
        probe.remove();
        return c;
      };
      gear.hidden = false;
      gear.addEventListener('click', () => {
        bridge.openSettings({ ...cfg, colors: { bg: color('--c-bg'), text: color('--c-text'), accent: color('--c-accent') },
          dark: document.documentElement.classList.contains('is-dark') }).catch(() => {});
      });
      bridge.addListener('settings', (e) => {
        if (e.type === 'link' && e.url) window.location.href = e.url;
        // Diese Seite hat keinen Cookie-Banner: auf der Startseite öffnen
        else if (e.type === 'action' && e.id === 'cookies') window.location.href = `${document.querySelector('.acct__back').getAttribute('href')}#app-cookies`;
      });
    }
  }

  // Nur im Theme-Editor: Beispieldaten, damit sich die Seite gestalten lässt
  if (!plugin) {
    if (root.hasAttribute('data-design-mode')) {
      renderSignedIn({
        firstName: 'Lorayn', lastName: 'Beispiel', emailAddress: { emailAddress: 'kundin@beispiel.de' },
        defaultAddress: { formatted: ['Lorayn Beispiel', 'Musterweg 1', '17419 Usedom', 'Deutschland'] },
        orders: { nodes: [
          { name: '#1042', processedAt: new Date().toISOString(), fulfillmentStatus: 'FULFILLED', financialStatus: 'PAID', totalPrice: { amount: '44.90', currencyCode: 'EUR' },
            lineItems: { nodes: [{ name: 'Shirt „Kiss ghost“', variantTitle: 'M', quantity: 1 }, { name: 'Schlüsselanhänger „Bad to the Bone“', quantity: 2 }] },
            fulfillments: { nodes: [{ latestShipmentStatus: 'IN_TRANSIT', trackingInformation: [{ company: 'DHL', url: 'https://www.dhl.de/' }] }] } },
          { name: '#1037', processedAt: new Date(Date.now() - 864e6).toISOString(), fulfillmentStatus: 'UNFULFILLED', financialStatus: 'PAID', totalPrice: { amount: '69.95', currencyCode: 'EUR' },
            lineItems: { nodes: [{ name: 'Oversize Shirt „Toxic Love“', variantTitle: 'L', quantity: 1 }] }, fulfillments: { nodes: [] } }
        ] }
      });
    }
    return;
  }
  load();
})();
